export const ENVIRONMENT = import.meta.env.VITE_ENV;
export const BASE_URL = import.meta.env.VITE_BASE_URL;
export const DOMAIN_URL = import.meta.env.VITE_DOMAIN_URL;
export const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;
export const AWS_BASE_URL = import.meta.env.VITE_AWS_BASE_URL;
export const FIREBASE_API_KEY = import.meta.env.VITE_APP_FIREBASE_API_KEY;
export const FIREBASE_AUTH_DOMAIN = import.meta.env
  .VITE_APP_FIREBASE_AUTH_DOMAIN;
export const FIREBASE_PROJECT_ID = import.meta.env.VITE_APP_FIREBASE_PROJECT_ID;
export const FIREBASE_STORAGE_BUCKET = import.meta.env
  .VITE_APP_FIREBASE_STORAGE_BUCKET;
export const FIREBASE_MESSAGING_SENDER_ID = import.meta.env
  .VITE_APP_FIREBASE_MESSAGING_SENDER_ID;
export const FIREBASE_APP_ID = import.meta.env.VITE_APP_FIREBASE_APP_ID;
export const FIREBASE_MEASUREMENT_ID = import.meta.env
  .VITE_APP_FIREBASE_MEASUREMENT_ID;
export const FIREBASE_NOTIFICATION_VAPID_KEY = import.meta.env
  .VITE_APP_FIREBASE_NOTIFICATION_VAPID_KEY;
export const GUJARAT_STATE_ID = import.meta.env.VITE_GUJARAT_STATE_ID;
export const AHMEDABAD_CITY_ID = import.meta.env.VITE_AHMEDABAD_CITY_ID;
export const APPARTMENT_CATEGORY_ID = import.meta.env
  .VITE_APPARTMENT_CATEGORY_ID;
export const COMMERCIAL_CATEGORY_ID = import.meta.env
  .VITE_COMMERCIAL_CATEGORY_ID;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
